module.exports = __webpack_public_path__ + "img/阵列2.246df492.svg";